import { API_config } from '../../config/apiConfig';

const traccarManagerUrl = API_config.traccarManagerApiUrl;
const bearerHeader = API_config.bearerAuthHeader;

/**
 * Sets the status of a device (SOS, OK, REDFLAG_SEND, REDFLAG_CONFIRM, or CLEAR)
 * @param {number|string} deviceId - Traccar Device ID
 * @param {string} status - One of SOS, OK, REDFLAG_SEND, REDFLAG_CONFIRM, or CLEAR
 * @param {Object} extra - Optional extra attributes to merge
 * @returns {Promise<Object>} The response from the backend
 */
export async function setDeviceStatus(deviceId, status, extra = {}) {
    try {
        const response = await fetch(`${traccarManagerUrl}?action=set_status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearerHeader
            },
            body: JSON.stringify({
                deviceId: parseInt(deviceId, 10),
                status,
                extra
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `Failed to set status ${status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('traccarManagerApi: setDeviceStatus error', error);
        throw error;
    }
}

/**
 * Removes a specific attribute from a device
 * @param {number|string} deviceId - Traccar Device ID
 * @param {string} key - The attribute key to remove
 * @returns {Promise<Object>} The response from the backend
 */
export async function removeDeviceAttribute(deviceId, key) {
    try {
        const response = await fetch(`${traccarManagerUrl}?action=remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearerHeader
            },
            body: JSON.stringify({
                deviceId: parseInt(deviceId, 10),
                key
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || `Failed to remove attribute ${key}`);
        }

        return await response.json();
    } catch (error) {
        console.error('traccarManagerApi: removeDeviceAttribute error', error);
        throw error;
    }
}

/**
 * Merges attributes into a device
 * @param {number|string} deviceId - Traccar Device ID
 * @param {Object} attributes - Object containing attributes to merge
 * @returns {Promise<Object>} The response from the backend
 */
export async function mergeDeviceAttributes(deviceId, attributes) {
    try {
        const response = await fetch(`${traccarManagerUrl}?action=merge`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': bearerHeader
            },
            body: JSON.stringify({
                deviceId: parseInt(deviceId, 10),
                attributes
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to merge attributes');
        }

        return await response.json();
    } catch (error) {
        console.error('traccarManagerApi: mergeDeviceAttributes error', error);
        throw error;
    }
}
